/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.CustomBranding {
    'use strict';

    interface IScope extends ng.IScope {
        bold: boolean,
        italic: boolean,
        underline: boolean,
        disabled: boolean,
        changed: Function,
        onClick: Function
    }

    export class FontStyleButtonsDirective implements angular.IDirective {
        restrict = 'E';
        template = `
            <div layout="row" flex="100">
                <md-button class="md-raised font-style-button bold"
                           ng-disabled="disabled"
                           ng-class="{'md-primary': bold}"
                           ng-click="onClick('bold')">B</md-button>
        
                <md-button class="md-raised font-style-button italic"
                           ng-disabled="disabled"
                           ng-class="{'md-primary': italic}"
                           ng-click="onClick('italic')">I</md-button>
        
                <md-button class="md-raised font-style-button underline"
                           ng-disabled="disabled"
                           ng-class="{'md-primary': underline}"
                           ng-click="onClick('underline')">U</md-button>
            </div>
        `;
        scope = {
            bold: '=',
            italic: '=',
            underline: '=',
            changed: '&',
            disabled: '=ngDisabled'
        };

        constructor(private $rootScope) {
            
        }

        link = (scope: IScope, element: JQuery) => {

            /**
             * Button click handler
             * */
            scope.onClick = (button: string): void => {
                scope[button] = !scope[button];
                setTimeout(() => {
                    scope.changed();
                    this.$rootScope.$digest();
                }, 0);
            }
        };

        static factory(): angular.IDirectiveFactory {
            let directive = ($rootScope) => {
                return new FontStyleButtonsDirective($rootScope);
            };
            directive.$inject = ["$rootScope"]
            return directive;
        }
    }
    angular.module('meevo.plugins.customBranding')
        .directive('fontStyleButtons', FontStyleButtonsDirective.factory());
}
